import React from 'react';
import SpinImage from '../components/Panel/SpinImage';


const SpinImagePage = (e) => {
//console.log(e);

  return (
    <div id="spinimagepage" style={{height: '100%'}}>
      <SpinImage urlImage={e.location.query.im} />
    </div>
  );
};

export default SpinImagePage;



/** WEBPACK FOOTER **
 ** ./src/containers/SpinImagePage.js
 **/